import { useQuery } from '@tanstack/react-query'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'
import { TournamentService } from '@/modules/tournament/api/services'

type TournamentPresetsResponse = {
	presets: Array<{
		preset: string
		name: string
		description: string
		bannerImage: string
		minTurnover: number
		minDeposit: number
		minBetAmount: number
		maxTransactionDay: number
		allowedGameTypes: string
		prizes: Array<{
			rank: number
			prizeAmount: number
		}>
	}>
}

const useQueryGetTournamentPresets = () => {
	return useQuery<TournamentPresetsResponse>({
		queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.PRESETS,
		queryFn: () => TournamentService.getTournamentPresets(),
	})
}

export default useQueryGetTournamentPresets
